export default "__VITE_ASSET__7Gl7BIxc__"